export default __webpack_public_path__ + "images/0x8f3cf7ad23cd3cadbd9735aff958023239c6a063.png";